import {
  AppDispatch,
  archiveOrganization,
  archiveOrganizationClear,
  archiveOrganizationRequest,
  getChildOrganizationListRequest,
  getClientOrganizationListRequest,
  getOrganizationListRequest,
  useDynamicSelector,
} from "@src/redux";
import { Button } from "antd";
import React, { useEffect } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";

interface ArchiveCardProps {
  name: string;
  worker: {
    name: string;
    id: string;
  };
  onCancel: () => void;
}

const ArchiveCard: React.FC<ArchiveCardProps> = ({
  worker,
  name,
  onCancel,
}) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const {
    result: archiveResult,
    loading: archiveLoading,
    error: archiveError,
  } = useSelector(archiveOrganization);
  const { filter: clientFilter } = useDynamicSelector("client_filter");
  const { pathname } = useLocation();

  useEffect(() => {
    if (archiveResult?.status === "success") {
      toast.success(t("archive_successfully", { name: name }));
      dispatch(archiveOrganizationClear());
      onCancel();
      if (!pathname.includes("clients")) {
        dispatch(
          getChildOrganizationListRequest({
            filter: {
              parentOrganizationId: id || "",
            },
            pagination: {
              pageLimit: 10,
              pageNumber: 1,
            },
          })
        );
      } else {
        dispatch(
          getClientOrganizationListRequest({
            ...clientFilter,
            pagination: { pageLimit: 10, pageNumber: 1 },
            sort: [
              {
                field: "name",
                order: "asc",
              },
            ],
          })
        );
      }
    } else if (archiveResult?.error?.message) {
      toast.error(archiveResult.error.message);
      dispatch(archiveOrganizationClear());
    }
  }, [archiveResult?.status]);

  const onArchiveClick = () => {
    dispatch(
      archiveOrganizationRequest({
        id: worker?.id || "",
      })
    );
  };

  return (
    <div>
      <span>{`Are you sure you want to archive the "${name}"?`}</span>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
        }}
      >
        <Button style={{ marginRight: "10px" }} onClick={onCancel} danger>
          {t("close")}
        </Button>
        <Button
          type="primary"
          onClick={onArchiveClick}
          loading={archiveLoading}
        >
          {t("archive")}
        </Button>
      </div>
    </div>
  );
};

export default ArchiveCard;
